import { PortfolioReference } from '../models/portfolio-reference';

/**
 *	To be used to build PortfolioReference - a class to refer to child portfolios in blending constructs.
 *  Adding only necessary fields to be used - hiding other attributes that exist in BaseHolding but are not used for PortfolioReference
 *
 * 	sample usage:
 * 		const portfolioRef = new PortfolioReferenceBuilder().setIdentifier('id').setWeight(50).build();
 * @identifier id of PortfolioReference
 * @description name of portfolio
 * @weight weight of the child in relation to the parent
 * @value amount
 * @subType type of Portfolio
 * @flags Object containing flags that is useful for determining characteristics of the portfolio
 * @peOrder order of this portfolio within the parent holdings
 */

export class PortfolioReferenceBuilder {
	private portfolioReference: PortfolioReference;

	constructor() {
		this.portfolioReference = new PortfolioReference();
	}

	public setDescription(description: string): PortfolioReferenceBuilder {
		this.portfolioReference.description = description || '';
		return this;
	}

	public setIdentifier(identifier: string): PortfolioReferenceBuilder {
		this.portfolioReference.identifier = identifier || '';
		return this;
	}

	public setIdentifierType(identifierType: string): PortfolioReferenceBuilder {
		this.portfolioReference.identifierType = identifierType || '';
		return this;
	}

	public setWeight(weight: number): PortfolioReferenceBuilder {
		this.portfolioReference.weight = weight;
		return this;
	}

	public setType(type: string): PortfolioReferenceBuilder {
		this.portfolioReference.type = type || '';
		return this;
	}

	public setSubType(subType: string): PortfolioReferenceBuilder {
		this.portfolioReference.subType = subType || '';
		return this;
	}

	public setValue(value: number): PortfolioReferenceBuilder {
		this.portfolioReference.value = value || 0;
		return this;
	}

	public setBaseModel(baseModel: string): PortfolioReferenceBuilder {
		this.portfolioReference.baseModel = baseModel;
		return this;
	}

	public setFlags(flags: any): PortfolioReferenceBuilder {
		this.portfolioReference.flags = flags;
		return this;
	}

	// Needed for APM sleeves - used when sending back to partner
	public setOtherIdentifiers(otherIdentifiers: any): PortfolioReferenceBuilder {
		this.portfolioReference.otherIdentifiers = otherIdentifiers;
		return this;
	}

	// Needed for APM sleeves - used to identify the portfolio reference is an APM sleeve
	public setOriginPlatform(originPlatform: any): PortfolioReferenceBuilder {
		this.portfolioReference.originPlatform = originPlatform;
		return this;
	}

	public setPeOrder(peOrder: number): PortfolioReferenceBuilder {
		this.portfolioReference.peOrder = peOrder;
		return this;
	}

	public setAladdinPortfolioCode(aladdinPortfolioCode: string): PortfolioReferenceBuilder {
		this.portfolioReference.aladdinPortfolioCode = aladdinPortfolioCode;
		return this;
	}

	public setTpmId(tpmId: string): PortfolioReferenceBuilder {
		this.portfolioReference.tpmId = tpmId;
		return this;
	}

	public build(): PortfolioReference {
		return this.portfolioReference;
	}
}
